import { ElementBase } from "./elementBase";

export class InputElement extends ElementBase<string> {
    controlType = 'input';
    type: string;
    placeholder: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || 'text';
        this.placeholder = options['placeholder'] || options['label'];
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/form/elements/elementInput.ts